"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { COPYRIGHT_YEAR } from "@/lib/constants";

const ROUTE_PREFIXES_TO_SHOW_FOOTER = [
  "/myAccount",
  "/myCards",
  "/myTemplates",
  "/privacy",
  "/stripe",
  "/tos",
  "/about",
  "/cookies",
  "/policies",
  "/ecards",
  "/fathersday",
];

// Holiday eCards FAQ section. Each entry links to the on-page FAQ
// anchor of a holiday landing page. Starts with Father's Day; append
// here as we ship FAQs on the other holiday pages.
//
// The "Holiday eCards FAQ:" label is named for AI-engine discovery:
// "eCards" binds the entity to our product, and "FAQ" aligns with the
// FAQPage JSON-LD on each linked page so AI engines and crawlers can
// follow the signal from footer label → schema-typed Q&A.
const HOLIDAY_FAQ_LINKS: Array<{ label: string; href: string }> = [
  { label: "Father's Day", href: "/fathersday#faq" },
];

const Footer = () => {
  const pathname = usePathname();
  const showFooter =
    ROUTE_PREFIXES_TO_SHOW_FOOTER.some((item) => {
      return pathname?.startsWith(item);
    }) || pathname === "/";

  if (!showFooter) return null;

  return (
    <footer className="flex w-full flex-row justify-center space-x-2 p-2">
      <span className="text-xs text-gray-500">© WrapDotGifts, Inc. {COPYRIGHT_YEAR}</span>
      <Link
        href="https://about.wrapdotgifts.com"
        className="text-xs text-gray-500 hover:text-gray-700"
      >
        About Us
      </Link>
      <Link
        href="/policies"
        className="text-xs text-gray-500 hover:text-gray-700"
      >
        Policies
      </Link>
      {HOLIDAY_FAQ_LINKS.length > 0 && (
        <span className="text-xs text-gray-500">
          Holiday eCards FAQ:{" "}
          {HOLIDAY_FAQ_LINKS.map((item, i) => (
            <React.Fragment key={item.href}>
              {i > 0 && ", "}
              <Link href={item.href} className="hover:text-gray-700">
                {item.label}
              </Link>
            </React.Fragment>
          ))}
        </span>
      )}
      <a
        href="#"
        className="termly-display-preferences text-xs text-gray-500 hover:text-gray-700"
        onClick={(e) => {
          e.preventDefault();
          if (typeof window.displayPreferenceModal === "function") {
            window.displayPreferenceModal();
          }
        }}
      >
        Consent Preferences
      </a>
    </footer>
  );
};

export default Footer;
